import { useEffect, useState } from 'react';

export const useJS = (): [boolean] => {
  const [isJS, setIsJS] = useState(false);

  useEffect(() => {
    setIsJS(!!typeof window);
  }, []);

  return [isJS];
};
